/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

/**
 * HTML Element utilities
 */
export class HTMLElements {

  public static setStyles(element: HTMLElement, styles: { [key: string]: any }) {
    Object.keys(styles).forEach(attribute => element.style[attribute] = styles[attribute]);
  }

  public static setClasses(element: HTMLElement, ...classes: string[]) {
    classes.forEach(c => element.classList.add(c));
  }

}
